import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { IdleContextProvider } from "@contexts/Idle";

import { JivoChat } from "@components/JivoChat";
import { PageLayout } from "@components/PageLayout";
import useAuth from "@hooks/useAuth";
import usePermissions from "@hooks/usePermissions";

export const PageLayoutProtected: FC = () => {
  const { user } = useAuth();
  const { allowedRoutes, routes, loading } = usePermissions();

  const location = useLocation();

  if (!user) {
    return <Navigate to="/" replace />;
  } else if (loading) {
    return null;
  } else if (user.enableFaceMatch && !user.isChecked) {
    return <Navigate to="/validacao" replace />;
  } else {
    // Encontra a chave mais específica (mais longa) que seja prefixo do pathname atual
    const bestMatch = Object.keys(routes)
      .filter((key) => location.pathname.startsWith(key))
      .sort((a, b) => b.length - a.length)[0];

    if (!bestMatch || !allowedRoutes.includes(bestMatch)) {
      return <Navigate to="/sem-acesso" replace />;
    }
  }

  return (
    <IdleContextProvider>
      <PageLayout showSider showHeader />
      {user.supportChat && <JivoChat />}
    </IdleContextProvider>
  );
};
